import React from 'react';
import { connect } from 'react-redux';
import * as css from './css/message';
import ChatMessage from 'enum/ChatMessage';

class Message extends React.Component {
  render() {
    const { className, message, user } = this.props;

    return (
      <css.Message className={className}>
        {message.userType === ChatMessage.FROM ? (
          <css.FromContainer>
            <css.Content>
              <div className='nickname'>{user.nickname || user.nickname}</div>
              <div className='message'>{message.content}</div>
            </css.Content>
            <css.Avatar />
          </css.FromContainer>
        ) : (
          <css.ToContainer>
            <css.Avatar>
              <img
                src={require('./img/service-avatar.png')}
                alt=''
                className='img'
              />
            </css.Avatar>
            <css.Content>
              <div className='nickname'>商城智能客服</div>
              <div className='message'>{message.content}</div>
            </css.Content>
          </css.ToContainer>
        )}
      </css.Message>
    );
  }
}

export default connect(state => {
  const { user } = state;

  return { user };
})(Message);
